import { Observable, map } from 'rxjs';
import { ExternalNotificationsApiServiceObservable, GetIndicatorResponse, PutIndicatorResponse } from '@kempoweroyj/ngx-external-notifications-api-client';
import { Injectable, inject } from '@angular/core';
import { AuthTokenService } from '@kempoweroyj/ngx-auth-token-service';

@Injectable({ providedIn: 'root' })
export class UnreadNotificationIndicatorService {
    readonly #notificationsApiServiceObservable = inject(ExternalNotificationsApiServiceObservable);
    readonly #authTokenService = inject(AuthTokenService);

    readonly #headers = {
        headers: {
            Authorization: 'Bearer ' + this.#authTokenService.jwt,
        },
    };

    getUnreadIndicator$(): Observable<boolean> {
        return this.#notificationsApiServiceObservable.getIndicator(this.#headers).pipe(
            map((res: GetIndicatorResponse) => {
                return res.newNotifications;
            })
        );
    }

    setUnreadIndicatorFalse$(): Observable<PutIndicatorResponse> {
        return this.#notificationsApiServiceObservable.putIndicator({ newNotifications: false }, this.#headers).pipe(
            map((res: PutIndicatorResponse) => {
                return res;
            })
        );
    }
}
